import { stubObject } from "lodash-es";
import calculateSpeeding from "./speeding";
import calculateDistance from "./distance";
import calculateRedLight from "./redLight";
import calculateMobilePhone from "./mobilePhone";
import calculateAlcohol from "./alcohol";

const methods = {
  SPEEDING: calculateSpeeding,
  DISTANCE: calculateDistance,
  RED_LIGHT: calculateRedLight,
  MOBILE_PHONE: calculateMobilePhone,
  ALCOHOL: calculateAlcohol,
};

const calculatePenalty = (data = {}) => {
  const calculateMethod = methods[data.VORWURF] || stubObject;
  const {
    fineAmount = 0,
    licencePoints = 0,
    drivingBanPeriod = 0,
  } = calculateMethod(data);

  return {
    fineAmount,
    licencePoints,
    drivingBanPeriodInMonths: drivingBanPeriod,
  };
};

export default calculatePenalty;
